<template>
  <header
    v-if="showHeader"
    id="header"
    :class="[{ materialfullscreen: isMaterialFullScreen }, hideDisplay]"
  >
    <div class="header_content">
      <div class="header_logo">
        <img src="@/assets/img/logo_myStage-GR.svg" />
      </div>

      <LessonTimer v-if="!hideDisplay" />
    </div>

    <div class="header_right_side_contents">
      <div v-if="!isAssistLesson && !isAssessmentLesson" class="layout_btn">
        <input
          id="TAB-01"
          value="lyt_1"
          type="radio"
          name="TAB"
          class="tab-switch"
          v-bind:checked="isStudent || !isDiscoveryLesson"
        />
        <label
          :class="['tab-label', { 'pointer-events-none' : isCmsPreview }]"
          for="TAB-01"
          v-if="isStudent || !isDiscoveryLesson"
          @click="isCmsPreview ? false : switchLayoutStyle(1)"
        >
          <img src="@/assets/img/layout_1_icn@2x.png" />
        </label>
        <input
          id="TAB-02"
          value="lyt_2"
          type="radio"
          name="TAB"
          class="tab-switch"
          v-bind:checked="!isStudent"
        />
        <label
          :class="['tab-label', { 'pointer-events-none' : isCmsPreview }]"
          :disabled="isCmsPreview"
          for="TAB-02"
          v-if="!isStudent || isIpadDevice"
          @click="isCmsPreview ? false : switchLayoutStyle(2)"
        >
          <img src="@/assets/img/layout_2_icn@2x.png" />
        </label>
        <input
          id="TAB-03"
          :checked="isVideoScreenLayout"
          value="lyt_3"
          type="radio"
          name="TAB"
          class="tab-switch"
        />
        <label class="tab-label" for="TAB-03" :class="{ 'pointer-events-none' : isCmsPreview }" @click="isCmsPreview ? false : switchLayoutStyle(3)">
          <img src="@/assets/img/layout_3_icn@2x.png" />
        </label>
      </div>
    </div>

    <LessonExit v-if="showExitButton" :trial-logout="trialLesson && logout" />
  </header>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import LessonTimer from '@/components/Lesson/Header/LessonTimer';
import LessonExit from '@/components/Lesson/Header/LessonExit';
import cmsPreview from '@/mixins/cmsPreview';

export default {
  props: {
    hideDisplay: {
      type: String,
      default: ''
    },
    trialLesson: {
      type: Boolean,
      default: false
    },
    logout: {
      type: Boolean,
      default: false
    },
    vocabulary: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LessonTimer,
    LessonExit
  },
  mixins: [cmsPreview],
  computed: {
    ...mapState('layout', [
      'layoutStyle',
      'isMaterialFullScreen',
      'layoutColor',
      'isIpadDevice',
      'isMobileSize'
    ]),
    ...mapGetters('layout', ['isVideoScreenLayout']),
    ...mapGetters(['isStudent', 'isAssistLesson', 'isAssessmentLesson', 'isDiscoveryLesson']),
    ...mapGetters('modal', ['isModalShowing']),

    headerLogo() {
      return require(`@/assets/img/logo_${this.layoutColor}@2x.png`);
    },

    showExitButton() {
      return !this.trialLesson || (this.trialLesson && this.logout);
    },

    showHeader() {
      if (this.isMobileSize && this.isModalShowing) {
        return false;
      }

      return true;
    }
  },
  methods: {
    ...mapActions('layout', ['switchLayoutStyle'])
  }
};
</script>

<style scoped>
  .pointer-events-none {
    pointer-events: none;
  }

  @media screen and (min-width: 960px) {
    .header_logo img {
      width: 102px;
      height: 24px;
    }
  }

  @media screen and (max-width: 959px) {
    .header_logo img {
      width: 76.5px;
      height: 18px;
    }
  }
</style>
